import angular from 'angular';
import workbenchLogs from './workbenchLogs';

export default angular
  .module('components.workbenchLogs', [])
  .component('workbenchLogs', workbenchLogs).name;
